import { render, staticRenderFns } from "./EditStory.vue?vue&type=template&id=ef90d128&"
import script from "./EditStory.vue?vue&type=script&lang=js&"
export * from "./EditStory.vue?vue&type=script&lang=js&"
import style0 from "./EditStory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports